import { getLocation } from '@/lib/actions/global/get-location'
import { cn } from '@/lib/utils'

import { DeviceCardList, ScrollArea } from '@/components/ui'

interface DeviceListProps extends React.ComponentPropsWithoutRef<'div'> {
  location?: any
}

export const DeviceList = async ({ className, location }: DeviceListProps) => {
  const res = await getLocation(location?.id)

  return (
    <ScrollArea
      className={cn(
        'relative w-full overflow-auto pr-4',
        'before:absolute before:left-0 before:right-0 before:top-0 before:z-10 before:h-8 before:bg-gradient-to-b before:from-gray-50 before:to-transparent before:content-[""]',
        'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-8 after:bg-gradient-to-t after:from-gray-50 after:to-transparent after:content-[""]',
        className,
      )}
      thumbClassName="bg-transparent"
    >
      <DeviceCardList
        className="flex flex-col gap-1 py-8"
        list={res?.devices}
      />
    </ScrollArea>
  )
}
